// extracted by mini-css-extract-plugin
export var mySwiper = "textReviews-module--mySwiper--fa7d7";
export var studentReview = "textReviews-module--student-review--03d43";
export var student__extra = "textReviews-module--student__extra--257d5";
export var student__img = "textReviews-module--student__img--46b4f";
export var student__info = "textReviews-module--student__info--ab143";
export var student__name = "textReviews-module--student__name--55b12";
export var student__wrapper = "textReviews-module--student__wrapper--85c40";
export var swiperButtonNext = "textReviews-module--swiper-button-next--d96f1";
export var swiperButtonPrev = "textReviews-module--swiper-button-prev--1bf84";
export var swiperButtons = "textReviews-module--swiper-buttons--729e3";
export var textReviewContainer = "textReviews-module--text-review-container--17d20";
export var textReviews = "textReviews-module--text-reviews--4eb23";